import {
  Trash2,
  Pencil,
  Search,
  File,
  Clipboard,
  ClipboardList,
  Folder,
  FolderOpen,
  Calendar,
  Plus,
  ListPlus,
  Dot,
  CircleDot,
  Minus,
  Ellipsis,
  XCircle,
  FileSpreadsheet,
  FileX,
  Link,
  Unlink,
  ChevronLeft,
  ChevronRight,
  Info,
  Grip,
  Eye,
  LogIn,
  ThumbsUp,
  ThumbsDown,
  ArrowBigUp,
  ArrowBigDown,
  SquareX,
  SquareCheck,
  Check,
  X,
  SquareCheckBig
} from 'lucide-vue-next';

export const lucideVueIcons = {
  trash: Trash2,
  pencil: Pencil,
  search: Search,
  file: File,
  clipboard: Clipboard,
  'clipboard-list': ClipboardList,
  folder: Folder,
  'folder-open': FolderOpen,
  calendar: Calendar,
  plus: Plus,
  'list-plus': ListPlus,
  dot: Dot,
  'circle-dot': CircleDot,
  minus: Minus,
  ellipsis: Ellipsis,
  xcircle: XCircle,
  xls: FileSpreadsheet,
  pdf: FileX,
  link: Link,
  unlink: Unlink,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  info: Info,
  grip: Grip,
  eye: Eye,
  login: LogIn,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  'arrow-big-up': ArrowBigUp,
  'arrow-big-down': ArrowBigDown,
  'square-x': SquareX,
  check: Check,
  x: X,
  'square-check': SquareCheck,
  'square-check-big': SquareCheckBig
};

export type LucideIconName = keyof typeof lucideVueIcons;